export const partnerConstants = {
    GET_PARTNER_LIST_SUCCESS: 'GET_PARTNER_LIST_SUCCESS',
    GET_PARTNER_LIST_FAILURE: 'GET_PARTNER_LIST_FAILURE',
};
